import React from 'react'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'
import { getDeep } from '../../../util/helpers'

const noSelect = {
  userSelect: 'none',
}

const ellipsis = {
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
}

const Table = ({ data, headers, dataKey }) => (
  <table
    className={[midas.table, midas.tableStriped].join(' ')}
    style={{ ...noSelect, tableLayout: 'fixed', position: 'relative' }}
  >
    <thead>
      <tr style={noSelect}>
        {headers.map(header => (
          <th style={{ ...(header.style || {}) }} key={header.key}>
            {header.text}
          </th>
        ))}
      </tr>
    </thead>
    <tbody style={noSelect}>
      {data.length ? (
        data.map(d => (
          <tr key={getDeep(d, dataKey)}>
            {headers.map(header => {
              const value = header.dataFunc
                ? header.dataFunc(d)
                : header.field && getDeep(d, header.field)
              return (
                <td
                  style={ellipsis}
                  title={value}
                  key={getDeep(d, dataKey) + header.key}
                >
                  {value}
                </td>
              )
            })}
          </tr>
        ))
      ) : (
        <tr>
          {headers.map(h => (
            <td key={`${h.key}-placeholder`} />
          ))}
        </tr>
      )}
    </tbody>
  </table>
)

Table.propTypes = {
  data: PropTypes.array.isRequired,
  headers: PropTypes.array.isRequired,
  dataKey: PropTypes.string.isRequired,
}

export default Table
